import React from 'react';

export function BlockedDiv(props: any) {
  const padding = props.alteredPadding ? '10px 0px 0px 10px' : '10px';

  return (
    <div
      style={{
        border: '1px solid #cacace',
        borderRadius: '4px',
        backgroundColor: '#f7f7f7',
        padding: padding,
        margin: '10px 0px 10px 0px',
      }}>
      {props.children}
    </div>
  );
}
